export default __webpack_public_path__ + "static/media/TreMellow.92bede4e.mp3";